
import Vue from "vue";
import $ from "jquery";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action, Mutation, State } from "vuex-class";
import { AxiosResponse } from "axios";

import { SchoolModel } from "@/models/academy.model";
import { CandidateModel } from "@/models/candidate.model";
import { isUniversity } from "@/functions/userinterface.function";

import toast from "@/functions/toast.function";
import Badge from "@/components/properties/Badge.vue";
import ModalAddSkill from "@/components/candidate/ModalAddSkill.vue";
import PaginationMiniComponent from "@/components/paginations/PaginationMini.vue";

@Component({
  components: {
    Badge,
    ModalAddSkill,
    PaginationMiniComponent,
  },
  filters,
})
export default class Active extends Vue {
  /* VUEX */

  // ACTION
  @Action("actionSelectCandidateActive", { namespace: "candidate" })
  private actionSelectCandidateActive: any;
  @Action("actionPaginationCandidateActive", { namespace: "candidate" })
  private actionPaginationCandidate: any;
  @Action("actionResetCandidate", { namespace: "candidate" })
  private actionResetCandidate: any;

  // STATE
  @State("school", { namespace: "academy" })
  private school: SchoolModel;
  @State("array_candidate_active", { namespace: "candidate" })
  private array_candidate!: Array<CandidateModel>;
  @State("pagination_candidate_active", { namespace: "candidate" })
  private pagination_candidate: any;
  @State("candidate", { namespace: "candidate" })
  private candidate: any;
  @State("locale")
  private locale: any;

  // MUTATION
  @Mutation("mutationArrayCandidateActive", { namespace: "candidate" })
  private mutationArrayCandidateActive: any;
  @Mutation("mutationPushArrayCandidateActive", { namespace: "candidate" })
  private mutationPushArrayCandidateActive: any;

  /* INITIALIZATION */

  private skills: string[] = [];
  private isShowAddSkill: boolean = false;
  private workingStatus: string[] = ["Employed", "Unemployed"];
  private verificationStatus: string[] = ["Verified", "Unverified"];

  private onLoad: boolean = false;
  private activePage: number = 1;

  constructor() {
    super();
  }

  private get wordingStudentID() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("student_id_nisn_2");
    }

    return this.$i18n.t("student_id_nisn");
  }

  /* LIFECYCLE */

  private created() {
    this.actionResetCandidate();
    const self = this;
    this.mutationArrayCandidateActive(new Array<CandidateModel>());
    this.clickSearch();
    $(document).ready(function () {
      $("#TableVerifyCandidate").scroll(function () {
        if (
          ($(this).scrollTop() as number) + ($(this).innerHeight() as number) >=
          $(this)[0].scrollHeight
        ) {
          if (!self.onLoad) {
            if (self.array_candidate.length == 0) {
              return;
            }

            if (self.onLoad) {
              return;
            }
            if (self.pagination_candidate.url && !self.onLoad) {
              setTimeout(() => {
                self.clickPage(self.activePage, self.pagination_candidate.url);
              }, 200);
            }
          }
        }
      });
    });
  }

  /* METHOD */

  private isCheckStatus(candidate: any) {
    // CHECK CANDIDATE PERCENTAGE (SHOULD BE SAME OR HIGHER THAN 60)
    return candidate.progress >= 60;
  }

  private clickSearch() {
    if (this.candidate.start_year && this.candidate.start_year < 0) {
      toast.warning(this.$t("warning_start_year_minus"));
      return;
    } else if (this.candidate.end_year && this.candidate.end_year < 0) {
      toast.warning(this.$t("warning_graduate_year_minus"));
      return;
    } else {
      this.actionSelectCandidateActive({
        callback: (response: AxiosResponse) => {
          if (response.data.next) {
            this.activePage++;
          }
          this.onLoad = false;
          this.mutationArrayCandidateActive(response.data.results);
        },
      });
    }
  }

  private clickPage(page: number, url: string) {
    this.onLoad = true;
    if (url) {
      this.actionPaginationCandidate({
        url,
        page,
        callback: (response: AxiosResponse) => {
          if (response.data.next) {
            this.activePage++;
          }
          this.onLoad = false;
        },
      });
    } else {
      this.clickSearch();
    }
  }

  private removeSkill(value: string) {
    const index = this.skills.indexOf(value);
    if (index > -1) {
      this.skills.splice(index, 1);
    }
  }

  private getStatus(data: any): string {
    if (data === "Unemployed") {
      return this.locale === "id" ? "Tidak bekerja" : data;
    }
    return this.locale === "id" ? "bekerja" : data;
  }

  private getLabel(major: any): string {
    if (this.locale === "id") {
      return major["translation"];
    }
    return major["label"];
  }
}
